import { render, staticRenderFns } from "./MassEditRooms.vue?vue&type=template&id=4f66a4aa&"
import script from "./MassEditRooms.vue?vue&type=script&lang=js&"
export * from "./MassEditRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports